import { dataEmpty, generateObjectDummyId } from "components/CommonLib/CommonLib";
import CustomTable from "components/CustomTable/CustomTableTypeA";
import { CustomRow, CustomTableContents } from "components/CustomTable/tableStyle";
import ComboBox from "components/LabelInput/ComboBox";
import DatePicker from "components/LabelInput/DatePicker";
import TextField from "components/LabelInput/TextField";
import NormalBtn from "components/NewButton/NormalBtn";
import TableTitleWithButton from "components/TableTitleWithButton/TableTitleWithButton";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";

const EduCard = forwardRef((props, ref) => {
  const [itemInfoList, setItemInfoList] = useState(props.staffInfoState.education);

  useEffect(() => {
    setItemInfoList(props.staffInfoState.education);
  }, [props.staffInfoState.education]);

  useImperativeHandle(ref, () => ({
    getItemList: () => {
      return itemInfoList;
    },
  }));

  const onItemPush = () => {
    // const methodId = uuidv4();

    const idx = itemInfoList.length;

    const baseItemInfo = {
      id: generateObjectDummyId(),
      idx: idx,
      degree: "",
      org_name: "",
      major: "",
      grad_type: "",
      grad_date: "",
    };

    if (itemInfoList.length === 0) {
      setItemInfoList([baseItemInfo]);
    } else {
      setItemInfoList([...itemInfoList, baseItemInfo]);
    }

    props.staffInfoState.education.push(baseItemInfo);
  };

  const onItemPop = (targetId) => {
    var array = [...itemInfoList]; // make a separate copy of the array
    const index = array.map((item) => item.item_id).indexOf(targetId);

    if (index !== -1) {
      array.splice(index, 1);
      props.staffInfoState.education.splice(index, 1);
      setItemInfoList(array);
    }
  };

  const itemList = new itemInfoTable(onItemPop);

  return (
    <div style={{ padding: "0.625rem 1.25rem", border: "1px solid #bbb", marginTop: "1rem" }}>
      <div style={{}}>
        <TableTitleWithButton
          titleLabel={"학력 사항"}
          buttonText={"추가"}
          onClickEvent={onItemPush}
        />
      </div>
      <div>
        <CustomTable
          columns_head={itemList.columns_head}
          table_title={itemList.table_title}
          rest_call={itemList.get_data_from_rest}
          row_render={itemList.create_table}
          rest_data={itemInfoList}
        />
      </div>
    </div>
  );
});
export default EduCard;

class itemInfoTable {
  table_title = "";
  // refundInfoList = [];
  btnPop = null;

  constructor(btnPop) {
    this.btnPop = btnPop;
  }

  create_table = (data, key) => {
    return (
      <CustomRow key={key} style={{ width: "100%" }}>
        <CustomTableContents width="10%">
          {/* {data.pay_method} */}
          <ComboBox
            justifyContent="center"
            comboItemWidth={"12rem"}
            labelText=""
            data={["고등학교", "학사", "석사", "박사"]}
            defaultValue={data.degree}
            onChangeCallback={(e) => {
              data.degree = e.target.value;
            }}
          />
        </CustomTableContents>

        <CustomTableContents width="10%">
          <TextField
            justifyContent="center"
            textBoxWidth={"14rem"}
            labelMarginLeft={"0rem"}
            textMarginRight={"0rem"}
            defaultValue={data.org_name}
            onChangeCallback={(e) => {
              data.org_name = e;
            }}
          />
        </CustomTableContents>

        <CustomTableContents width="10%">
          <TextField
            justifyContent="center"
            textBoxWidth={"14rem"}
            labelMarginLeft={"0rem"}
            textMarginRight={"0rem"}
            labelText=""
            defaultValue={data.major}
            onChangeCallback={(e) => {
              data.major = e;
            }}
          />
        </CustomTableContents>
        <CustomTableContents width="10%">
          <ComboBox
            justifyContent="center"
            comboItemWidth={"12rem"}
            data={["재학중", "수료", "졸업", "자퇴"]}
            defaultValue={data.grad_type}
            onChangeCallback={(e) => {
              data.grad_type = e.target.value;
            }}
          />
        </CustomTableContents>
        <CustomTableContents width="10%">
          <DatePicker
            // inputRef={tmTryTimeRef}
            justifyContent="center"
            labelWidth={"0rem"}
            minWidth={"12rem"}
            defaultValue={data.grad_date}
            onChangeCallback={(e) => {
              data.grad_date = e;
            }}
          />
        </CustomTableContents>
        <CustomTableContents width="5%">
          {/* {data.remove} */}
          {data.is_lock ? (
            <NormalBtn name="삭제" width="4.5rem" onClick={() => this.btnPop(data.item_id)} />
          ) : (
            ""
          )}
        </CustomTableContents>
      </CustomRow>
    );
  };
  columns_head = [
    { title: "학위구분", field: "select" },
    { title: "학교", field: "pay_method" },
    { title: "전공", field: "pay_method" },
    { title: "졸업여부", field: "card_no" },
    { title: "졸업일", field: "card_no" },
    { title: "", field: "remove" },
  ];
  get_data_from_rest = (stateData) => {
    if (dataEmpty(stateData)) {
      return [];
    }

    return stateData;
  };
}
